'use client';

import Background from '~/components/marketing/sections/new-hero/background';
export default Background;
